import { forwardRef } from 'react'

import type { InputHTMLAttributes, Ref, ReactElement, ReactNode } from 'react'

import VanillaTextInput from '../../Basic/TextInput'
import Wrapper from '../Wrapper'

export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string
  error?: ReactNode
  label?: string
  labelPosition?: 'top' | 'left'
  size?: Exclude<SIZES, 'large'>
}

const TextInput = forwardRef(
  ({ className, error, size = 'medium', ...props }: Props, ref: Ref<HTMLInputElement>): ReactElement => {
    return (
      <Wrapper className={className} error={error}>
        <VanillaTextInput {...props} ref={ref} size={size} />
      </Wrapper>
    )
  }
)

TextInput.displayName = 'TextInput'

export default TextInput
